export enum ChartType {
  None = 0,
  Bar = 1,
  Pie = 2,
  Line = 3,
  Gauge = 4,
  Map = 5,
  Custom = 99,
}
